<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								View Training Record
							</div>
				
							<div class="page_main">
								<div class="training-page">
				
									<el-form ref="form" :model="info" label-position="top" class="cr-form">
				
										<el-form-item label="Name" class="full-width-item">
											<el-input v-model="info.title" readonly class="gray-input"></el-input>
										</el-form-item>
				
										<el-form-item label="Description" class="full-width-item">
											<el-input v-model="info.description" readonly class="gray-input"></el-input>
										</el-form-item>
				
									</el-form>
				
									<!-- Training Requirements -->
									<div class="file-panel">
										<div class="panel-header">
											<div class="panel-title">
												Training Requirements
											</div>
				
											<el-input
												v-model="requestKeyword"
												placeholder="Search"
												clearable
												class="search-input"
											>
												<i slot="prefix" class="el-input__icon el-icon-search"></i>
											</el-input>
										</div>
				
										<el-table
											ref="tableRef"
											:data="requestTableData"
											border
											class="table_el"
											header-cell-class-name="table-header"
											empty-text="No training requirements found."
										>
				
											<el-table-column
												prop="item_name"
												label="Item ID"
												sortable
												min-width="180"
											/>
				
											<el-table-column
												prop="leixing_name"
												label="Training Item Type"
												sortable
												min-width="260"
											/>
				
											<el-table-column
												prop="is_certification_name"
												label="Certification Required?"
												sortable
												min-width="180"
											/>
				
										</el-table>
									</div>
				
									<!-- Task History -->
									<div class="file-panel">
				
										<div class="panel-header">
				
											<div class="panel-title">
												Task History
											</div>
				
											<el-input
												v-model="searchKeyword"
												placeholder="Search"
												clearable
												class="search-input"
											>
												<i slot="prefix" class="el-input__icon el-icon-search"></i>
											</el-input>
				
										</div>
				
										<el-table
											:data="generalTableData"
											border
											class="file-table"
											header-cell-class-name="table-header-cell"
											empty-text="No task history found."
										>
				
											<el-table-column
												prop="item_name"
												label="Task Name"
												min-width="180"
												sortable
											/>
				
											<el-table-column
												prop="company_name"
												label="Company"
												min-width="110"
												sortable
											/>
				
											<el-table-column
												prop="departments_name"
												label="Department"
												min-width="110"
												sortable
											/>
				
											<el-table-column
												label="Task Status / Result"
												min-width="180"
												sortable
											>
												<template slot-scope="scope">
													<div v-if="scope.row.status == 1">In Progress</div>
													<div v-if="scope.row.status == 2">Completed</div>
													<div v-if="scope.row.status == 9">Withdrawn</div>
												</template>
											</el-table-column>
				
											<el-table-column
												label="Comments"
												min-width="120"
												sortable
											>
												<template slot-scope="scope">
													<div>{{ scope.row.remark || "/" }}</div>
												</template>
											</el-table-column>
				
											<el-table-column
												prop="apply_username"
												label="Task Owner"
												min-width="180"
												sortable
											/>
				
											<el-table-column
												prop="end_time"
												label="Due Date"
												min-width="160"
												sortable
											/>
				
											<el-table-column
												label="Completion Date"
												min-width="150"
												sortable
											>
												<template slot-scope="scope">
													<div>{{ scope.row.app_time || "/" }}</div>
												</template>
											</el-table-column>
				
										</el-table>
									</div>
				
									<div class="footer-btn">
										<el-button type="primary" @click="handleClose">
											Close
										</el-button>
									</div>
				
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import {
		trainRecordDetail
	} from "@/api/trainManage/configTrain/trainRecord/index";
	export default {
		components: {
			headers,
			slider,
		},
		data() {
			return {
				isLoading: true,
				id: "",
				info: {
					title: "",
					description: "",
				},
				searchKeyword: "",
				requestKeyword: "",
				requestData: [],
				tableData: [],
			};
		},
		created() {
			let that = this;
			that.id = that.$route.query.id;
		},
		mounted() {
			let that = this;
			that.isLoading = false;
			that.getArchivalDetail();
		},
		computed: {
			requestTableData() {
				return this.filterTableData(this.requestData, this.requestKeyword);
			},
			generalTableData() {
				return this.filterTableData(this.tableData, this.searchKeyword);
			},
		},
		methods: {
			filterTableData(source, keyword) {
				if (!keyword || !keyword.trim()) return source;
				const lowerKeyword = keyword.toLowerCase().trim();
				return source.filter((item) => {
					const text = this.flattenValues(item).toLowerCase();
					return text.includes(lowerKeyword);
				});
			},
			flattenValues(data) {
				if (data === null || data === undefined) return "";
				if (Array.isArray(data)) {
					return data.map((item) => this.flattenValues(item)).join(" ");
				}
				if (typeof data === "object") {
					return Object.values(data)
						.map((val) => this.flattenValues(val))
						.join(" ");
				}
				return String(data);
			},
			getArchivalDetail() {
				let that = this;
				trainRecordDetail({
					id: that.id,
				}).then((res) => {
					if (res.code == 200) {
						// console.log("********", res);
						that.info = res.data;
						that.requestData = res.data.requirements_list;
						that.tableData = res.data.apply_list;
					}
				});
			},
			handleClose() {
				let that = this;
				window.close();
			},
			getStatusClass(status) {
				if (status === "Completed") return "status-success";
				if (status === "Withdrawn") return "status-danger";
				if (status === "In Progress") return "status-warning";
				return "";
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.training-page {
		padding: 12px;
		box-sizing: border-box;
	}

	.full-width-item {
		margin-top: 8px;
	}

	/* 输入框统一风格 */
	.gray-input ::v-deep .el-input__inner {
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
		border-radius: 8px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
	}

	.gray-input ::v-deep .el-textarea__inner {
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
		border-radius: 8px;
		font-size: 14px;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.panel-title {
		font-size: 18px;
		font-weight: 700;
		color: #222;
		line-height: 32px;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.footer-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 50px;
	}

	::v-deep .el-form-item__label {
		padding-bottom: 8px;
		font-size: 14px;
		line-height: 20px;
		color: #2f343b;
		font-weight: 700;
	}
</style>